import { FormErrorMessage } from '@chakra-ui/react';

const FieldError = ({ children, isDrawer = true, pl = 198 }) => (
    <FormErrorMessage
        justifyContent={isDrawer ? 'flex-start' : null}
        pl={pl}
        mt={0}>
        {children}
    </FormErrorMessage>
);

export default FieldError;
